import { render, staticRenderFns } from "./GlobalToast.vue?vue&type=template&id=10a032da&scoped=true"
import script from "./GlobalToast.vue?vue&type=script&lang=js"
export * from "./GlobalToast.vue?vue&type=script&lang=js"
import style0 from "./GlobalToast.vue?vue&type=style&index=0&id=10a032da&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10a032da",
  null
  
)

export default component.exports